
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avantages",
      function () {
        return require("private-next-pages/avantages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avantages"])
      });
    }
  